import { useState, useEffect } from 'react';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleConfigure = () => {
    localStorage.setItem('cookieConsent', 'configured');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white shadow-lg border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-4">
          <div className="flex-1 text-dark text-sm">
            <p>
              Utilizamos cookies propias y de terceros para mejorar nuestros servicios. Puedes aceptar todas las cookies o configurar tus preferencias.{' '}
              <a href="#" className="text-primary hover:underline">
                Política de Cookies
              </a>
            </p>
          </div>
          <div className="flex items-center space-x-3">
            <button
              onClick={handleConfigure}
              className="px-5 py-2.5 border border-gray-300 text-dark rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Configurar
            </button>
            <button
              onClick={handleAccept}
              className="px-5 py-2.5 bg-primary text-white rounded-lg text-sm font-medium hover:bg-primary/90 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;